module.exports = __webpack_public_path__ + "static/img/illu-2.dbf9497.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/illu-2.png
// module id = 318
// module chunks = 9